import { render, staticRenderFns } from "./SalaryCalculator.vue?vue&type=template&id=5db0fe72&"
import script from "./SalaryCalculator.vue?vue&type=script&lang=js&"
export * from "./SalaryCalculator.vue?vue&type=script&lang=js&"
import style0 from "./SalaryCalculator.vue?vue&type=style&index=0&id=5db0fe72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports